/**
* 基础菜单 供货关系类型管理
*/
<template>
  <div class="contianer">
    <div class="address">
      <div class="ment flex_box">
        <p class="text f20 fontWeight">供货身份</p>
        <el-row>
<!--          <el-button type="primary" plain size="mini" @click="edit()">编辑</el-button>-->
        </el-row>
      </div>

      <div class="mt20">
        <el-descriptions title="" :column="1" border>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 70px">公司名称</div>
            </template>
            {{tableData.seller_name}}
          </el-descriptions-item>
          <el-descriptions-item>
            <template slot="label">
              <div style="width: 70px;">供货身份</div>
            </template>
            {{tableData.agent_type=='2890'?'供应商':tableData.agent_type=='2891'?'商家':''}}
          </el-descriptions-item>
        </el-descriptions>
      </div>
    </div>

    <!-- 弹窗 -->
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               title="修改供货身份"
               :visible.sync="editDialogVisible"
               width="30%"
               center>
      <el-form label-width="120px" :model="addForm" :rules="rules" ref="addForm" class="addForm">
        <el-form-item label="公司名称" prop="seller_name">
          <el-input size="small" v-model="addForm.seller_name" placeholder="请输入公司名称" clearable disabled></el-input>
        </el-form-item>
        <el-form-item label="供货身份" prop="agentType">
          <el-select v-model="addForm.agentType" placeholder="请选择供货身份" clearable>
            <el-option label="供应商" value="2890"></el-option>
            <el-option label="商家" value="2891"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="sure('addForm')" :disabled="!isCanSubmit">确 定</el-button>
            <el-button @click="editDialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import {
    agentInfo,    // 详情
    agentUpdate   // 修改
  } from '../../api/basisMG'

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        editDialogVisible: false, //控制页面显示与隐藏
        dialogVisible: false,
        tableData: {
          seller_name: '',
          agent_type: '',
        },
        addForm: {
          id: '',
          seller_name: '',
          agentType: '',
        },
        // rules表单验证
        rules: {
          seller_name: [{required: true, message: '请输入店铺名称', trigger: 'blur'}],
          agentType: [{required: true, message: '请选择供货身份', trigger: 'blur'}]
        },
        isCanSubmit: true,
      }
    },
    // 注册组件
    components: {},

    /**
     * 创建完毕
     */
    created() {
      this.getData()
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取数据
      getData() {
        this.loading = true
        agentInfo()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (res.content) {
                this.tableData = res.content;
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      edit() {
        this.editDialogVisible = true;
        this.addForm.seller_name = this.tableData.seller_name;
        this.addForm.agentType = this.tableData.agent_type.toString()
      },
      sure(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isCanSubmit = false;
            this.loading = true;
            let body = {
              agentType:Number(this.addForm.agentType)
            }
            agentUpdate(body)
              .then(res => {
                this.isCanSubmit = true;
                this.loading = false
                if (res.success == false) {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                } else {
                  this.$message({
                    type: 'success',
                    message: '保存成功!'
                  })
                  this.editDialogVisible = false;
                  this.getData()
                }
              })
              .catch(err => {
                this.isCanSubmit = true;
                this.loading = false
                this.$message.error('网络错误,请稍后再试!')
              })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }
</script>


<style scoped>
  .contianer {
    height: calc(100% - 60px);
    background: #fff;
    padding: 20px;
    border-radius: 8px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  /deep/ .addForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .addForm .el-input--small {
    width: 320px;
  }

  .mt20 {
    margin-top: 20px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .flex_box {
    display: flex;
  }

  .flex_box {
    display: flex;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .saleTitle {
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 25px;
  }

  .picTitle {
    color: #333333;
    font-size: 15px;
    font-weight: 400;
    margin: 20px 0;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .address {
    width: 500px;
    height: 168px;
    margin: 30px 0 0 36px;
  }

  .ment {
    padding: 2px 12px;
    justify-content: space-between;
  }

  .text {
    font-family: 'PingFang SC';
    font-style: normal;
    line-height: 28px;
    color: #409EFF;
  }

  .w120 {
    width: 120px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar {
    width: 120px;
    height: 120px;
    display: block;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 120px;
    line-height: 120px;
    text-align: center;
    border: 1px dashed #DCDFE6;
  }

  .avatar-uploader {
    height: 122px;
  }

  /deep/ .image-slot {
    text-align: center;
    margin-top: 50%;
    transform: translateY(-50%);
  }

  /deep/ .el-descriptions-row th {
    width: 120px !important;
    border: 0 !important;
    border-bottom: 1px solid #EBEEF5 !important;
    background: #F5F7FA;
  }

  /deep/ .el-descriptions-row td {
    border: 0 !important;
    border-bottom: 1px solid #EBEEF5 !important;
  }

</style>





// WEBPACK FOOTER //
// src/views/supply/supplyType.vue